<template>
  <button
    type="button"
    class="tw:font-medium tw:text-primary tw:hover:underline tw:disabled:cursor-not-allowed tw:disabled:text-muted tw:disabled:no-underline">
    <slot />
  </button>
</template>
